import { z } from 'zod';
/**
 * Audit-kereses: indokolt betekintes masok beszelgeteseibe.
 *
 * Lasd docs/18-audit-kereses.html. Ugy nelkul nincs betekintes; az ugyet egy
 * MASIK jogosult hagyja jova (negy szem), es minden lepes a kitorolhetetlen
 * betekintesi naploba kerul.
 */
export const AUDIT_REASON_CATEGORIES = {
    legal: 'Hatósági / jogi megkeresés',
    employer: 'Munkáltatói vizsgálat',
    privacy: 'Adatvédelmi (GDPR) kérelem',
    security: 'Biztonsági incidens',
};
export const auditReasonCategorySchema = z.enum(['legal', 'employer', 'privacy', 'security']);
/** Ennyi karakter alatt nem indoklas, hanem kitoltes. */
export const AUDIT_JUSTIFICATION_MIN = 50;
/** Egy jovahagyott ugy legfeljebb ennyi oraig el (7 nap). */
export const AUDIT_MAX_DURATION_HOURS = 168;
/** Egy keres ennyi oraig var jovahagyasra, utana lejar. */
export const AUDIT_REQUEST_TTL_HOURS = 24;
/** Az audit-jog alapertelmezett ervenyessege napokban. */
export const AUDIT_GRANT_DEFAULT_DAYS = 90;
export const AUDIT_GRANT_MAX_DAYS = 365;
/**
 * A hatokor: KIKET es MELY csatornakat, MILYEN idoszakban.
 *
 * Szemelynel: az o DM-jei es csoportos DM-jei, plusz a sajat uzenetei barmely
 * csatornaban. Csatornanal: a csatorna teljes tartalma. Az idoszak mindkettore
 * szukit.
 */
export const auditScopeSchema = z
    .object({
    userIds: z.array(z.string().min(1)).max(50).default([]),
    channelIds: z.array(z.string().min(1)).max(50).default([]),
    /** ISO datum (napra). */
    from: z.string().date(),
    to: z.string().date(),
})
    .refine((scope) => scope.userIds.length + scope.channelIds.length > 0, {
    message: 'Legalább egy személyt vagy csatornát meg kell adni.',
})
    .refine((scope) => scope.from <= scope.to, {
    message: 'Az időszak vége nem lehet a kezdete előtt.',
});
export const auditCaseRequestInput = z.object({
    reasonCategory: auditReasonCategorySchema,
    justification: z
        .string()
        .trim()
        .min(AUDIT_JUSTIFICATION_MIN, `Az indoklás legalább ${AUDIT_JUSTIFICATION_MIN} karakter.`)
        .max(4000),
    reference: z.string().trim().max(200).optional(),
    scope: auditScopeSchema,
    durationHours: z.number().int().min(1).max(AUDIT_MAX_DURATION_HOURS),
    /** Ujrahitelesites: a sajat jelszo ES a hitelesito alkalmazas kodja. */
    password: z.string().min(1),
    code: z.string().trim().min(6).max(8),
});
export const auditCaseDecisionInput = z.object({
    approve: z.boolean(),
    note: z.string().trim().max(1000).optional(),
    password: z.string().min(1),
    code: z.string().trim().min(6).max(8),
});
export const auditTotpConfirmInput = z.object({ code: z.string().trim().min(6).max(8) });
export const auditGrantInput = z.object({
    userId: z.string().min(1),
    days: z.number().int().min(1).max(AUDIT_GRANT_MAX_DAYS).default(AUDIT_GRANT_DEFAULT_DAYS),
});
export const AUDIT_CASE_STATE_LABELS = {
    requested: 'Jóváhagyásra vár',
    active: 'Nyitva',
    rejected: 'Elutasítva',
    expired: 'Lejárt',
    closed: 'Lezárva',
};
/**
 * Kiszolgalo-szintu audit-beallitasok - a szuperadmin allitja.
 *
 * `notifySubjects`: az ugy vegen (lezaras vagy lejarat) az erintettek
 * tajekoztatast kapnak. Kapcsolhato, mert hogy kotelezo-e, az jogi dontes.
 */
export const AUDIT_SETTINGS_KEY = 'audit.settings';
export const auditSettingsSchema = z.object({
    notifySubjects: z.boolean(),
    /**
     * Mikor kapcsoltak BE. Csak az ezutan veget ero ugyek erintettjei kapnak
     * levelet - a bekapcsolas nem kuld visszamenoleg minden regi ugyrol.
     * A szerver allitja, a kliens nem kuldi.
     */
    notifySubjectsSince: z.string().nullable().optional(),
});
export const DEFAULT_AUDIT_SETTINGS = {
    notifySubjects: false,
    notifySubjectsSince: null,
};
export const AUDIT_LOG_ACTION_LABELS = {
    'grant.created': 'Jog kiosztva',
    'grant.self': 'Jog önkiosztva (indulás)',
    'grant.revoked': 'Jog visszavonva',
    'case.requested': 'Ügy kérve',
    'case.approved': 'Ügy jóváhagyva',
    'case.rejected': 'Ügy elutasítva',
    'case.closed': 'Ügy lezárva',
    'case.export': 'Export',
    'case.search': 'Keresés az ügyben',
    'case.view': 'Beszélgetés megnyitva',
    'case.file': 'Melléklet megnyitva',
    'log.viewed': 'Napló megtekintve',
    'reauth.failed': 'Sikertelen újrahitelesítés',
    'settings.changed': 'Beállítás módosítva',
    'totp.enrolled': 'Kétlépcsős azonosítás beállítva',
    'totp.reset': 'Kétlépcsős azonosítás visszaállítva',
    'log.verified': 'Lánc ellenőrizve',
    'case.subjects_notified': 'Érintettek tájékoztatva',
};
export const AUDIT_MATCH_LABELS = {
    text: 'szövegben',
    deleted: 'törölt üzenetben',
    revision: 'korábbi változatban',
};
//# sourceMappingURL=audit-search.js.map